module.exports = __webpack_public_path__ + "media/images/Lock_Shadow_Silver_Unlocked_38-2398a9d9154035c38c4f9a1140fe89ac.png";